module.exports = __webpack_public_path__ + "static/media/lightning.215c196d.png";